/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiGET, apiGETPaginated, apiPOST, apiPUT, apiDELETE} from "./RequestsCore";

/**
 * Returns all the existing entities with pagination. Objects are in 'data' and pagination is in 'meta' and 'links'.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getEntitiesPaginated(filters) {
    return await apiGETPaginated('/api/entities', filters);
}

/**
 * Returns all the existing entities with pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getEntities() {
    return await apiGET('/api/entities');
}

/**
 * Returns all the existing entities without pagination.
 *
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function getAllEntitiesWithoutPagination() {
    return await apiGET('/api/all-entities-without-pagination');
}

/**
 * Returns the expected entity.
 *
 * @param entity_id
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getEntity(entity_id) {
    return await apiGET('/api/entity/' + entity_id);
}

/**
 * Creates a new entity with the provide data.
 *
 * @param entity
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createEntity(entity) {
    return await apiPOST('/api/entity', entity);
}

/**
 * Updates the provided entity with the provide data.
 *
 * @param entity
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function editEntity(entity) {
    return await apiPUT('/api/entity/' + entity.id, entity);
}

/**
 * Deletes the provided entity
 *
 * @param entity
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteEntity(entity) {
    return await apiDELETE('/api/entity/' + entity.id);
}
